import _classCallCheck from "/Users/dstein/dev/jaxcore/spin-a-sketch/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/dstein/dev/jaxcore/spin-a-sketch/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/dstein/dev/jaxcore/spin-a-sketch/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/dstein/dev/jaxcore/spin-a-sketch/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/dstein/dev/jaxcore/spin-a-sketch/node_modules/@babel/runtime/helpers/esm/inherits";
import EventEmitter from 'events';

var Listener =
/*#__PURE__*/
function (_EventEmitter) {
  _inherits(Listener, _EventEmitter);

  function Listener(postCommand) {
    var _this;

    _classCallCheck(this, Listener);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Listener).call(this));
    _this.postCommand = postCommand;
    return _this;
  }

  _createClass(Listener, [{
    key: "start",
    value: function start() {
      console.log('listen start');
      this.postCommand({
        listenCommand: {
          command: 'start'
        }
      });
    }
  }, {
    key: "stop",
    value: function stop() {
      console.log('listen stop');
      this.postCommand({
        listenCommand: {
          command: 'stop'
        }
      });
    }
  }, {
    key: "startContinuous",
    value: function startContinuous(options) {
      console.log('startContinuous', options);
      this.postCommand({
        listenCommand: {
          command: 'start-continuous',
          arguments: options
        }
      });
    }
  }, {
    key: "stopContinuous",
    value: function stopContinuous() {
      this.postCommand({
        listenCommand: {
          command: 'stop-continuous'
        }
      });
    }
  }, {
    key: "recognizedText",
    value: function recognizedText(text) {
      this.emit('recognized', text);
    }
  }, {
    key: "onStart",
    value: function onStart() {
      this.emit('start', text);
    }
  }, {
    key: "onStop",
    value: function onStop() {
      this.emit('stop', text);
    }
  }, {
    key: "onStartContinuous",
    value: function onStartContinuous() {
      this.emit('start-continuous', text);
    }
  }, {
    key: "onStopContinuous",
    value: function onStopContinuous() {
      this.emit('stop-continuous', text);
    }
  }]);

  return Listener;
}(EventEmitter);

export default Listener;